<video
  src="/images/home/banner2.mp4"
  [muted]="true"
  autoplay
  playsinline
  loop
></video>

<div class="content">
  <!-- <img class="left" src="/images/home/styles/product2.webp" alt="product" /> -->

  <div class="texts">
    <h2>Your everyday euphoria.</h2>
    <h3>
      Wander freely. Live beautifully. Discover effortless style crafted for the
      natural you.
    </h3>
  </div>
  <!-- <img class="right" src="/images/home/styles/product1.webp" alt="product" /> -->
</div>
